import Phaser from 'phaser';
import { CONFIG } from '../config.js';
import { Enemy } from './Enemy.js';

const C = CONFIG.COLORS;

export class Boss extends Enemy {
  constructor(scene, x, y, bossConfig) {
    super(scene, x, y, 'slime');
    const cfg = bossConfig || CONFIG.BOSSES.basic;
    this.setTexture(cfg.texture || 'boss');
    this.setScale(CONFIG.BOSS_DISPLAY_SCALE);
    const hitR = this.width * 0.22;
    this.body.setCircle(hitR, this.width / 2 - hitR, this.height / 2 - hitR);

    this.enemyType = 'boss';
    this.isBoss = true;
    this.maxHp = Math.round(CONFIG.BOSS_HP * (cfg.hpMult || 1));
    this.hp = this.maxHp;
    this.damage = CONFIG.BOSS_DAMAGE;
    this.baseSpeed = CONFIG.BOSS_SPEED;
    this.speedMult = 1;

    this.dashUntil = 0;
    this.nextDashAt = scene.time.now + CONFIG.BOSS_DASH_INTERVAL_MS;
    this.minionThresholds = [0.75, 0.5, 0.25];

    this.verbText.setStyle({
      fontSize: '14px',
      color: '#fde047',
      stroke: '#0f0d2c',
      strokeThickness: 5,
    });
  }

  preUpdate(time, delta) {
    Phaser.Physics.Arcade.Sprite.prototype.preUpdate.call(this, time, delta);
    this.activeRing.setPosition(this.x, this.y);
    this.verbText.setPosition(this.x, this.y - this.displayHeight * 0.65 - 10);

    const player = this.scene.player;
    if (!player || !player.alive) {
      this.body.setVelocity(0, 0);
      return;
    }
    if (time < this.dashUntil) return;
    if (time >= this.nextDashAt) {
      this.startDash();
      return;
    }
    this.scene.physics.moveToObject(this, player, this.baseSpeed);
  }

  startDash() {
    const player = this.scene.player;
    const angle = Math.atan2(player.y - this.y, player.x - this.x);
    this.body.setVelocity(
      Math.cos(angle) * CONFIG.BOSS_DASH_SPEED,
      Math.sin(angle) * CONFIG.BOSS_DASH_SPEED
    );
    this.dashUntil = this.scene.time.now + CONFIG.BOSS_DASH_DURATION_MS;
    this.nextDashAt = this.scene.time.now + CONFIG.BOSS_DASH_INTERVAL_MS;
    this.setTintFill(0xffffff);
    this.scene.time.delayedCall(150, () => { if (this.active) this.clearTint(); });
    if (this.scene.audio) this.scene.audio.bossRoar();
  }

  takeDamage(amount) {
    const dead = super.takeDamage(amount);
    const ratio = this.hp / this.maxHp;
    while (this.minionThresholds.length && ratio <= this.minionThresholds[0]) {
      this.minionThresholds.shift();
      this.summonMinions();
    }
    return dead;
  }

  summonMinions() {
    const scene = this.scene;
    if (!scene || !scene.spawnSystem) return;
    for (let i = 0; i < 3; i++) {
      const angle = (i / 3) * Math.PI * 2 + Math.random() * 0.4;
      const dist = 60 + Math.random() * 20;
      const x = Phaser.Math.Clamp(this.x + Math.cos(angle) * dist, 30, CONFIG.GAME_WIDTH - 30);
      const y = Phaser.Math.Clamp(
        this.y + Math.sin(angle) * dist,
        CONFIG.PLAY_AREA_TOP + 20,
        CONFIG.PLAY_AREA_BOTTOM - 20
      );
      scene.spawnSystem.spawnMinion(x, y);
    }
  }
}
